import type { ChartData } from 'chart.js'

import { BarChart } from '@/components/charts/bar-chart.tsx'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.tsx'

import { EmptyChartData } from './empty-chart-data.tsx'
import type { ToggleChartOptions } from './types'

interface Props {
  data?: ChartData<'bar', (number | [number, number] | null)[], unknown>
  isFetching: boolean
  title: string
  totalValue: string | undefined
  toggleOptions?: ToggleChartOptions
  showLabels?: boolean
}

export const BarChartCard = ({
  data,
  isFetching,
  title,
  totalValue = '0',
  toggleOptions,
  showLabels,
}: Props) => {
  return (
    <Card className="flex flex-col xl:justify-between">
      <CardHeader>
        <CardTitle className="text-xl font-semibold leading-none text-text-default">
          <div className="flex w-full justify-between">{totalValue || 0}</div>
        </CardTitle>
        <CardDescription className="text-text-sub">
          <div className="grid grid-flow-row justify-between sm:grid-flow-col">
            <p>{title}</p>
            <div className="flex gap-3 text-sm font-medium text-secondary-500 dark:text-white">
              {showLabels &&
                data &&
                data.datasets.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="flex items-center gap-1"
                    >
                      <div
                        className="h-[8px] w-[8px] rounded"
                        style={{
                          backgroundColor: item.backgroundColor?.toString(),
                        }}
                      />
                      {item.label}
                    </div>
                  )
                })}
            </div>
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isFetching || !data ? (
          <EmptyChartData isFetching={isFetching} />
        ) : (
          <BarChart
            data={data}
            toggleOptions={toggleOptions}
          />
        )}
      </CardContent>
    </Card>
  )
}
